<template>
	<div class="u-bg-lines-topdown u-padd-top-half">
		<div class="variation-container max-width-lg u-mrg-center wrapper" id="product-variations">
			<h4 class="h h-sm">Product Variations & Specifications</h4>
			<table class="w100 variations u-padd-btm-half">
				<tbody>
					<tr class="pointer-none">
						<td class="u-font-aeonik-bold u-padd-left">Name #</td>
						<td class="u-font-aeonik-bold u-txt-center">Item #</td>
						<td class="u-font-aeonik-bold u-txt-center">Size</td>
					</tr>
					<product-variation-item
						v-for="(product, index) in filteredItems"
						:key="index"
						:item="product"
					></product-variation-item>
				</tbody>
			</table>

			<button v-if="totalItems != 0 && totalShowing < totalItems" class="load-more u-txt-center u-mrg-top-half u-mrg-btm-half u-padd-all-qtr cursor-pointer w100 btn btn--primary pagination__next" @click="loadMore();">Load More</button>
			<div
				v-if="totalItems != 0 && totalShowing < totalItems"
				@click="viewAll();"
				class="u-txt-center"
				
			>
			<a class="link link-cta cursor-pointer" tabindex="0" @click="viewAll();">View All</a>
			</div>
		</div>			
	</div>
</template>

<script>
import axios from "axios";
import ProductVariationItem from "./ProductVariationItem.vue";
export default {
	name: 'ProductVariations',
	components: { ProductVariationItem },
	props: {},
	data() {
		return {
			products: [],
			selectedItem: null,
			currentPage: 1,
			totalItems: null,
			totalShowing: 5,
			increment: 10,
		};
	},
	created() {
		//or can pull path from a prop passed into the component
	},
	mounted() {
		this.setGallery(window.variations[0]);
		this.getGalleryContent();
	},
	methods: {
		setGallery(response) {
			this.products = response;
			this.totalItems = parseInt(response.length);
			this.getGalleryContent();
		},
		getGalleryContent() {
			this.loading = true;
		},
		loadMore() {
			if (this.totalShowing >= this.totalItems) return;
			this.totalShowing =
				this.totalShowing + this.increment >= this.totalItems
					? this.totalItems
					: this.totalShowing + this.increment;
		},
		viewAll() {
			this.totalShowing = this.totalItems;
		},
	},
	computed: {
		filteredItems() {
			return this.products.slice(0, this.totalShowing).map((item) => {
				return item;
			});
		},
	},
};
</script>
